import { createClient } from '@supabase/supabase-js';

const FALLBACK_SUPABASE_URL = 'https://vcdvljmsovunibcncutw.supabase.co';
const FALLBACK_SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjZHZsam1zb3Z1bmliY25jdXR3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MTg5NzQsImV4cCI6MjA5NDA5NDk3NH0.XBh3Z3RaUORL_PgUiNvwpntLp0yXc9OwXtE7de7qass';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || FALLBACK_SUPABASE_URL;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || FALLBACK_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    // On the web the recovery / magic links land back in the browser, so the
    // session has to be picked up from the URL fragment.
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

export type AccountRole = 'client' | 'provider' | 'admin';

/** Where a signed-in user belongs. `null` means the account is banned. */
export async function resolveUserRole(userId: string): Promise<AccountRole | null> {
  const { data, error } = await supabase
    .from('profiles')
    .select('account_type, is_admin, is_banned')
    .eq('id', userId)
    .maybeSingle();

  if (error || !data) {
    // Fallback: the is_banned column may not exist on older databases.
    const { data: fallback } = await supabase
      .from('profiles')
      .select('account_type, is_admin')
      .eq('id', userId)
      .maybeSingle();
    if (fallback?.is_admin) return 'admin';
    if (fallback?.account_type === 'provider') return 'provider';
    return 'client';
  }

  if (data.is_banned) return null;
  if (data.is_admin) return 'admin';
  if (data.account_type === 'provider') return 'provider';
  return 'client';
}

export const homePathForRole = (role: AccountRole): string =>
  role === 'admin' ? '/admin' : role === 'provider' ? '/pro' : '/app';
